import type { CalculationProductTypes } from '../interfaces/calculations';

export enum END_TIME_STATUS {
  'endingTodayProlongation',
  'endingToday',
  'endingProlongation',
  'ending',
  'endedRecentlyProlongation',
  'endedRecently',
  'active',
  'ended',
}

export const PROLONGATION_STATUSES = [
  END_TIME_STATUS.endingTodayProlongation,
  END_TIME_STATUS.endedRecentlyProlongation,
  END_TIME_STATUS.endingProlongation,
];

export const CALCULATIONS_TYPES: CalculationProductTypes[] = [
  'osago',
  'travelInsurance',
  'propertyInsurance',
  'mortgageInsurance',
  'accidentInsurance',
  'kasko',
];
